import React, { ReactNode } from 'react';
import { useQuery } from '@apollo/client';
import { broadcastApi } from 'modules/broadcasts';
import { PortalNotificationsDrawerRenderProps } from '../types';

interface Props {
  isDrawerOpen: boolean;
  children: (sendCreditApplicationRenderProps: PortalNotificationsDrawerRenderProps) => ReactNode;
}

export const ApiContainer = ({ isDrawerOpen, children }: Props) => {
  const { data: broadcastsData, loading: isBroadcastsLoading } = useQuery(broadcastApi.getBroadcastsSharedWithAccount, {
    fetchPolicy: 'no-cache',
    skip: !isDrawerOpen,
  });

  return (
    <>
      {children({
        broadcasts: broadcastsData?.broadcast?.broadcastsSharedWithAccount ?? [],
        isDataLoading: isBroadcastsLoading,
      })}
    </>
  );
};
